import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card-body pb-0" }
const _hoisted_4 = { class: "row mb-6" }
const _hoisted_5 = { class: "col-lg-12 col-form-label required fw-bold fs-6" }
const _hoisted_6 = { class: "col-lg-12" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-12 fv-row" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "form-check form-check-inline form-check-solid mt-5" }
const _hoisted_11 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_12 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_13 = { class: "indicator-label" }
const _hoisted_14 = { class: "indicator-progress" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = {
  class: "alert alert-primary",
  role: "alert"
}
const _hoisted_18 = { class: "d-flex justify-content-between" }
const _hoisted_19 = { class: "mt-4" }
const _hoisted_20 = { class: "card bg-success bg-opacity-25 h-100" }
const _hoisted_21 = { class: "card-header flex-nowrap border-0 pt-9" }
const _hoisted_22 = { class: "card-title w-100 d-block" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-10" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lightbulb fs-3 me-3 text-gray-900" }, null, -1)
const _hoisted_26 = {
  key: 0,
  href: "#",
  class: "fs-4 fw-bold text-hover-primary text-gray-900 m-0"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 2,
  href: "#",
  class: "fs-4 fw-bold text-hover-primary text-gray-900 m-0"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = { class: "col-2 d-flex flex-column align-items-end" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "card-body d-flex flex-column pb-8" }
const _hoisted_38 = { class: "d-flex align-items-center flex-wrap mb-5 fs-6" }
const _hoisted_39 = { class: "text-success fw-bolder me-2" }
const _hoisted_40 = { class: "d-flex align-items-center" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["card mb-5 mb-xxl-8", { 'animate-once': _ctx.showPulse }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Form, {
            id: "kt_add_action_form",
            class: "form",
            novalidate: "novalidate"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("pages.ideas.ideaDesc")), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                        placeholder: _ctx.$t('pages.ideas.ideaDesc'),
                        name: "idea",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.idea.idea) = $event))
                      }, null, 8, _hoisted_9), [
                        [_vModelText, this.idea.idea]
                      ]),
                      _createElementVNode("label", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          name: "anonymous",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.idea.anonymous) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, this.idea.anonymous]
                        ]),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("pages.ideas.anonymous")), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.isEditMode)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-secondary me-2",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
              }, _toDisplayString(_ctx.$t("general.cancel")), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "submit",
            id: "kt_account_profile_details_submit",
            ref: "submitButton1",
            class: "btn btn-primary",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addIdea && _ctx.addIdea(...args)))
          }, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.isEditMode ? _ctx.$t("general.update") : _ctx.$t("general.save")), 1),
            _createElementVNode("span", _hoisted_14, [
              _createTextVNode(_toDisplayString(_ctx.$t("general.pleaseWait")) + " ", 1),
              _hoisted_15
            ])
          ], 512)
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("p", _hoisted_19, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("pages.ideas.ideaToActionPlan")), 1)
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary btn-sm",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ name: 'roadmap' })))
          }, _toDisplayString(_ctx.$t("pages.ideas.toRoadmap")), 1)
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.category.ideas, (idea) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-4 mb-4",
        key: idea.pk
      }, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  (idea.anonymous)
                    ? (_openBlock(), _createElementBlock("a", _hoisted_26, "Anonyme"))
                    : (idea.userprofile.user_type.slug == 'obea_admin')
                      ? (_openBlock(), _createElementBlock("a", _hoisted_27))
                      : (_openBlock(), _createElementBlock("a", _hoisted_28, _toDisplayString(idea.userprofile.lastname) + " " + _toDisplayString(idea.userprofile.firstname), 1)),
                  _hoisted_29,
                  _createElementVNode("i", null, _toDisplayString(_ctx.$moment(idea.date_created).format("DD/MM/YYYY")), 1)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  (this.$store.getters.currentUser.user.userprofile.id === idea.userprofile.id)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.editIdea(idea)),
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm mb-2"
                      }, _hoisted_33, 8, _hoisted_31))
                    : _createCommentVNode("", true),
                  (this.$store.getters.currentUser.user.userprofile.id === idea.userprofile.id)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.deleteIdea(idea)),
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                      }, _hoisted_36, 8, _hoisted_34))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, _toDisplayString(idea.idea), 1)
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("i", {
                onClick: ($event: any) => (_ctx.likeIdea(idea)),
                class: _normalizeClass(['cursor-pointer', idea.user_has_liked ? 'fas fa-heart text-danger' : 'far fa-heart']),
                onMouseover: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hover = true)),
                onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hover = false)),
                style: _normalizeStyle({ color: _ctx.hover ? 'red' : (idea.user_has_liked ? 'red' : 'inherit') })
              }, null, 46, _hoisted_41),
              _createElementVNode("span", _hoisted_42, _toDisplayString(idea.like_count) + " " + _toDisplayString(_ctx.$t("pages.ideas.like")), 1)
            ])
          ])
        ])
      ]))
    }), 128))
  ]))
}